<template>
  <div :class="['side_navbar', {'sidebar-expanded': !isSidebarExpanded }]">
    <v-navigation-drawer v-model="drawer" :rail="rail" ref="drawer" permanent color="#00114B" @click="rail = false" style="width: auto;"
      class="p-2">
      <!-- Add content for the drawer here -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            <a href="#" class="">
              <img src="../assets/images/BB-logo-1.png" height="28" alt="Blubirch Logo" v-if="isSidebarExpanded" />
              <img src="../assets/images/bb-logo-big-2.png" height="40" width="195" alt="Blubirch Logo" v-else />
            </a>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <div style="width: 200px;" v-if="!isSidebarExpanded">
          <v-btn-toggle
            v-model="toggle_button"
            color="#dbe6ff"
            class="rounded-lg w-100 mt-3 mb-1"
            style="max-height: 40px; margin-left: 18px;"
            @update:modelValue="toggleButtonValue"
          >
            <v-btn value="tag" class="text-none" size="large" style="flex: 1;">
              Tag ID
            </v-btn>

            <v-btn value="ird" class="text-none" size="large" style="flex: 1;">
              IRD
            </v-btn>
          </v-btn-toggle>
        </div>
      <v-list-item v-if="!isSidebarExpanded">
        <v-list-item-content>
          <v-list-item-title class="title">
            <v-text-field 
                v-model="search" 
                prepend-inner-icon="mdi-magnify" 
                class="mt-2 search-expanded rounded-search" 
                placeholder="Search-Item"
                append-inner-icon="mdi-fullscreen" 
                color="primary" 
                solo 
                density="compact"
               @keydown.enter="searchItem" 
               variant="outlined"
               ></v-text-field>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-menu v-else :close-on-content-click="false" @click:outside="closeMenu" location="end" class="search_menu" v-model="search_popup">
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props" @click="openSearchMenu">
            <v-list-item-content>
              <v-list-item-title>
                <v-icon style="background: white;padding: 1px;border-radius: 6px;min-width:28px; min-height: 30px; color:#0275d8;">mdi-magnify</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list class="menupopup" style="width: 230px;">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" class="ma-2 search-collapsed" label="Search-Item"
                  append-inner-icon="mdi-fullscreen" color="primary" variant="outlined"
                  @keydown.enter="searchItem"></v-text-field>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-list dense :class="isSidebarExpanded ? 'sidebar-collapsed': 'navbarExpanded'">
        <template v-for="item in itemsDrawer" :key="item.index"> 
          <!-- When Drawer is Expanded -->
          <v-list-group v-if="item.children && !isSidebarExpanded && shouldShowChild(item)" :key="item.index"
          @click = "setActive(item.index,'parent')" :class="[{ active: activeParentIndex === item.index || activeChildIndex === item.index },{ 'disabled-span' : checkDisability(item) }]"
            class="parent-item" v-model="item.model">
            <template v-slot:activator="{ props }">
              <v-list-item-content style="text-align: left;" v-bind="props" :id="`button_${item.index}`" @click.stop="handleActivatorClick(item.index, $event)">
                <v-list-item-title  class="customParentSlider"
                :style="(activeParentIndex === item.index || activeChildIndex === item.index) ? 'color:#5A98E1;' : 'color:#ffffff;'"
                  style="font-weight:600;font-size:14px; cursor: pointer;" v-if="shouldShowChild(item)">
                  <img :src="item.icon" width="33" height="33" class="img-fluid" />
                  {{ item.text }}
                  <v-icon v-bind="props" class="expand-icon">
                    {{ item.model ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                  </v-icon>
                  <span class="active-list-item1"
                  v-if="(activeParentIndex === item.index || activeChildIndex === item.index) && !isSidebarExpanded">&nbsp;&nbsp;</span>
                  <span class="active-list-item2"
                  v-if="(activeParentIndex === item.index || activeChildIndex === item.index) && !isSidebarExpanded">&nbsp;&nbsp;</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list v-for="(child,childIndex) in item.children" :key="child?.index" class="py-0 text-left">
              <v-list-item link :to="child.link"
                @click.stop="setActive(child.index,'child')" 
                style="border-radius: 9px;"
                :class="[{ active: activeIndex === child.index, disabled: isChildDisabled(child.text) },{ 'disabled-span' : checkDisability(child) }]"
                class="childHoverSlider py-0" v-if="shouldShowChild(item, child?.index || childIndex)" :disabled="isChildDisabled(child.text)">
                <v-list-item-content>
                  <v-list-item-title style="font-size: .8125rem;font-weight: 500; line-height: 1rem;">
                    <span :style="activeChildIndex === child.index ? 'color:#ffffff; padding-top: 0px;' : 'color:#ffffff;'">{{ child.text
                      }}</span>
                      <span class="active-list-item1a" style="border-radius: 9px;"
                        v-if="activeChildIndex == child.index">&nbsp;&nbsp;</span>
                      <span class="active-list-item2a" style="border-top-right-radius: 9px !important;border-bottom-right-radius: 9px !important;"
                        v-if="activeChildIndex == child.index">&nbsp;&nbsp;</span>
                  </v-list-item-title>
                </v-list-item-content>  
              </v-list-item>
            </v-list>
          </v-list-group>

          <!-- When Drawer is Collapsed -->
          <v-menu v-else-if="item.children && isSidebarExpanded && shouldShowChild(item)" :close-on-content-click="false"
            @click:outside="closeMenu" location="end" v-model="item.v_menu_popup">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" @click="openCollapsedMenu(item)"
                :class="[{ active: activeParentIndex === item.index },{ 'disabled-span' : checkDisability(item) }]">
                <v-list-item-content>
                  <v-list-item-title
                    class="customParent">
                    <img :src="item.icon" width="32" height="32" class="img-fluid" />
                    <span :style="activeIndex === item.index ? 'color:#5A98E1;' : 'color:#ffffff;'">{{ item.text
                      }}</span>
                    <v-icon style="color:white;position: absolute; right: -5px;">
                    </v-icon>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list class="menupopup">
              <label class="pl-1" style="color: #00114B;"><b>{{ item.text }}</b></label>
              <v-list-item v-for="(child, i) in item.children" :key="i" link :to="child.link" style="text-decoration: none !important;height: 42px!important;" :disabled="isChildDisabled(child.text)">
                <v-list-item-content @click="setActive(child.index,'child')"
                  :class="[{ active: activeChildIndex === child.index },{ 'disabled-span' : checkDisability(child) }]"
                  class="childHover">
                  <v-list-item-title>
                    <span style="font-weight: 400;">{{ child.text }}</span>
                  </v-list-item-title>
                  <!-- <span class="active-list-item3"
                    v-if="activeIndex === child.index && isSidebarExpanded">&nbsp;&nbsp;</span> -->
                  <span class="active-list-item4"
                    v-if="activeIndex === child.index && isSidebarExpanded">&nbsp;&nbsp;</span>
                  <!-- <span class="active-list-item5"
                    v-if="activeIndex === child.index && isSidebarExpanded">&nbsp;&nbsp;</span> -->
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Items without children -->
          <v-list-item v-else-if="shouldShowChild(item)" link :to="item.link" @click="setActive(item.index,'without_child')"
            :class="[{ active: activeIndex === item.index },{ 'disabled-span' : checkDisability(item) }]" class="parent-item">
            <v-list-item-content>
              <v-list-item-title style="float:left;"
                :class="{ customParent: isSidebarExpanded }">
                <img :src="item.icon" width="33" height="33" class="img-fluid" />
                <span :class="{ hover: hoverIndex === item.index }" class="customParentSlider pl-1"
                  :style="activeIndex === item.index ? 'color:#5A98E1;' : 'color:#ffffff;'"
                  style="font-weight:600;font-size:14px;">{{ item.text }}</span>
              </v-list-item-title>
              <span class="active-list-item1"
                v-if="activeIndex === item.index && !isSidebarExpanded">&nbsp;&nbsp;</span>
              <span class="active-list-item2"
                v-if="activeIndex === item.index && !isSidebarExpanded">&nbsp;&nbsp;</span>
            </v-list-item-content>
          </v-list-item>

        </template>
      </v-list>
    </v-navigation-drawer>
    <v-btn variant="text" icon @click="toggleNavbar" class="nav-arrow">
      <v-icon style="font-size: 16px; width: 12px; height: 18px; align-items: center; color:#1A1B35;">
        {{ isSidebarExpanded ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left' }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { private_market_place } from '@/backend/axios';
import { mapState } from "vuex";
import riaIcon from '@/assets/images/icons/ria.png';
import rimsIcon from '@/assets/images/icons/rims.png';
import settingIcon from '@/assets/images/icons/setting.png';
import claimTrackingIcon from '@/assets/images/icons/claim-tracking.png';
import anaylticsIcon from '@/assets/images/icons/analytics.png';
import notificationIcon from '@/assets/images/icons/notification2.png';
import generateTag from '@/assets/images/icons/generate-tag.png';
import privateMarketplace from '@/assets/images/icons/private-marketplace.png';
import pendingApprival from '@/assets/images/icons/pending_approval.svg';
import { moduleAccessFunc } from '@/backend/axios/moduleAccess';
import { ref } from 'vue';
export default {
	data() {
		return {
			drawer: true,
			// rail: true,
      rail: this.$store.state.isSidebarExpanded,
			compress_nav: require('@/assets/logo.png'),
			activeNavButon: 'markdown',
			collapse_logo: false,
      toggle_button: 'tag',
			itemsDrawer: [
				{
					text: "RIA",
					icon: riaIcon,
					link: { name: "ReturnCreationRia" },
					v_menu_popup: false,
					children: [
						{
							text: "Return Creation",
							icon: riaIcon,
							link: { name: "ReturnCreationRia" },
							index: 101,
						},
						{
							text: "Return Approval",
							icon: riaIcon,
							link: { name: "dealer_partner_return_approval" },
							index: 102,
						},
						{
							text: "Reverse Logistics",
							icon: riaIcon,
							link: { name: "ReverseLogistics" },
							index: 105,
						},
						{
							text: "Tour Plan",
							icon: riaIcon,
							link: { name: "tourVisit" },
							index: 106,
						},
						{
							text: "Partner Request",
							icon: riaIcon,
							link: { name: "serviceRequest" },
							index: 1106,
						},
            {
							text: "Request & Tickets",
							icon: riaIcon,
							link: { name: "ReturnCreationRia" },
							index: 1107,
						}
					],
					index: 1,
          model: true,
				},
				{
					text: "RIMS",
					icon: rimsIcon,
					// link: { name: "ftaDisposition" },
					v_menu_popup: false,
					children: [
            {
							text: "PRD",
							icon: settingIcon,
							link: { name: "PRD" },
							index: 109,
						},
						{
							text: "Disposition",
							icon: settingIcon,
							// link: { name: 'reverseDisposition' },
							index: 107,
						},						
						{
							text: "Inwarding",
							icon: settingIcon,
							link: { name: "inward" },
							index: 110,
						},
            {
                text: "Grading",
                icon: settingIcon,
                link: { name: "grading" },
                index: 118,
            },
            // {
            //   text: "Pending Approval",
            //   icon: pendingApprival,
            //   link: { name: "physicalinspectionApproval" },
            //   v_menu_popup: false,
            //   index: 108,
            // },
            {
              text: "Change Disposition",
              icon: require("@/assets/images/icons/setting.png"),
              link: { name: "changeDisposition" },
              index: 131,
            },
						{
							text: "Put Away / Pick Up",
							icon: settingIcon,
							link: { name: "PutAway" },
							index: 111,
						},
						{
							text: "Transfer",
							icon: settingIcon,
							link: { name: "Transfer" },
							index: 112,
						},
						{
							text: "Dispatch",
							icon: settingIcon,
							link: { name: "NewDispatch" },
							index: 113,
						},              
						{
							text: "Cycle Count",
							icon: settingIcon,
							link: { name: "PhysicalInspection" },
							index: 114,
						},
            {
              text: "Claim Tracking",
              icon: claimTrackingIcon,
              link: { name: "threePClaim" },
              v_menu_popup: false,
              index: 151,
           },
          //  {
          //     text: "Generate IDs",
          //     icon: generateTag,
          //     link: { name: "generate" },
          //     v_menu_popup: false,
          //     index: 152,
          //   },
            // {
            //   text: "Generate Box ID's",
            //   icon: generateTag,
            //   link: { name: "generateBoxid" },
            //   v_menu_popup: false,
            //   index: 153,
            // },            
					],
					index: 2,
          model: true
				},
        {
					text: "Generate IDs",
					icon: generateTag,
					link: { name: "generate" },
					v_menu_popup: false,
					index: 10,
				},
        {
					text: "Pending Approval",
					icon: pendingApprival,
					link: { name: "physicalinspectionApproval" },
					v_menu_popup: false,
					index: 11,
				},         
				{
					text: "Analytics",
					icon: anaylticsIcon,
					// link: { name: "ftaDisposition" },
					v_menu_popup: false,
					children: [
						{
							text: "Dashboard",
							icon: settingIcon,
							link: { name: "dashboardNew" },
							index: 115,
						},
						{
							text: "Report",
							icon: settingIcon,
							link: { name: "Report" },
							index: 116,
						},
            // {
            //   text: "Closed Report",
            //   icon: require("@/assets/images/dash.png"),
            //   link: { name: "ClosedReport" },
            //   index: 130,
            // },
					],
					index: 3,
          model: true
				},
				{
					text: "Notification",
					icon: notificationIcon,
					link: { name: "AlertComponent" },
					v_menu_popup: false,
					index: 4,
				},		
				       
				{
					text: "Settings",
					icon: settingIcon,
					// link: { name: "Dispatch" },
					v_menu_popup: false,
					children: [
						{
							text: "Inward",
							icon: settingIcon,
							link: { name: "StoreMasterUploadList" },
							index: 117,
						},
						{
							text: "Putaway",
							icon: settingIcon,
							link: { name: "SubLocations" },
							index: 119,
						},
						{
							text: "Insurance",
							icon: settingIcon,
							link: { name: "Insurance" },
							index: 120,
						},
						{
							text: "Item Master",
							icon: settingIcon,
							link: { name: "ItemMaster" },
							index: 121,
						},
						{
							text: "Location Master",
							icon: settingIcon,
							link: { name: "locationMaster" },
							index: 122,
						},
						{
							text: "User Master",
							icon: settingIcon,
							link: { name: "userMaster" },
							index: 123,
						},
						{
							text: "Vendor Master",
							icon: settingIcon,
							link: { name: "vendorMater" },
							index: 124,
						},
						{
							text: "Approval Matrix",
							icon: settingIcon,
							link: { name: "approvalMatrix" },
							index: 125,
						},
						{
							text: "Error Listing",
							icon: settingIcon,
							link: { name: "ErrorListing" },
							index: 126,
						},
            {
							text: "Manage Buyer",
							icon: settingIcon,
							link: { name: "ManageUser" },
							index: 128,
						},
            {
							text: "AI Pricing File Upload",
							icon: settingIcon,
							link: { name: "LotFileuploadComm" },
							index: 140,
						},
						{
							text: "API Configuration",
							icon: settingIcon,
							link: { name: "ApiConfiguration" },
							index: 127,
						},
            // {
            //   text: "Client Masters",
            //   icon: settingIcon,
            //   link: { name: "ClientMasters" },
            //   index: 133,
            // }
						
						// {
						// 	text: "User Control",
						// 	icon: settingIcon,
						// 	link: { name: "UserControl" },
						// 	index: 129,
						// },
            
					],
          model:true,
					index: 7,
				}				        
         
			],
			activeIndex: null,
			activeParentIndex: null,
			activeChildIndex: null,
			openMenus: [],
			openMenuIndex: null,
			hoverIndex: null,
			childhoverIndex: null,
			isHoveringGroup: false,
			search_popup: false,
			search: '',
      role: '',
      configurations:[],
      app_modules: [],
		}
	},
  watch:{
        '$store.state.searched_tagid': function(newTab) {
            this.searched_data = this.search = newTab           
          },

    },
  mounted() {
    this.rail = this.isSidebarExpanded;
    this.activeParentIndex = this.$store.state.activeParentIndex;
    this.activeChildIndex = this.$store.state.activeChildIndex;
    if (this.activeParentIndex !== null) {
      this.updateFirstTimeActive(this.activeParentIndex, 'parent');
    }
    if (this.activeChildIndex !== null) {
      this.updateFirstTimeActive(this.activeChildIndex, 'child');
    }
  },
  created() {
    this.organization_name = this.$store.state.organization_name;
    this.configurations = this.$store.state.configurations;
    this.app_modules = this.$store.state.currentUser.app_modules;
    if(this.$isWhirlpoolClient()){
      this.itemsDrawer[0].children[2].link = { name: "ftaReverseLogistics"}
    }
    if(this.organization_name == 'Voltas' || this.organization_name == 'Crompton' || this.organization_name == 'Blubirch'){
      this.itemsDrawer[4].children.push({
              text: "Grade Configuration",
							icon: settingIcon,
							link: { name: "grade" },
							index: 143,
          })
    }
    if(this.organization_name == 'Voltas' || this.$isRelianceClient() || this.$isWhirlpoolClient()){
      this.itemsDrawer[4].children.push({
        text: "Report Creator",
        icon: require("@/assets/images/dash.png"),
        link: { name: "reportBuilder" },
        index: 132,
      });
    }

     if(this.configurations.some(item => item.constant === "USE_CRM_SURROGATE" && item.is_enabled === true)){
       this.itemsDrawer[0].children.push({ 
           text: "BB CRM Surrogate",
           icon: generateTag,
           link: { name: "bbCRMSurtogateFile" },
           v_menu_popup: false,
           index: 150
       })
    }

    if(this.organization_name !== 'Crompton' && this.organization_name !== 'Blubirch'){
      this.itemsDrawer[6].children.push(
        {
					text: "Private Marketplace",
					icon: privateMarketplace,
					// link: { name: "threePClaim" },
					v_menu_popup: false,
					index: 8,
				}, 
      );
    }
    // this.activeIndex = this.$store.state.lotIds;
    const active_index = this.$store.state.active_index
    this.role = this.$store.state.currentUser.roles[0]
    if(active_index)
      this.updateFirstTimeActive(active_index)
    else if(this.organization_name == 'Voltas' || this.$isWhirlpoolClient())
      this.updateFirstTimeActive(101)
    else this.updateFirstTimeActive(107)
    if (this.signedIn === false) {      
      if (!(this.$route.name === "EmailVerification" || this.$route.name === "OTPVerification" || this.$route.name === "ResetPassword" || this.$route.name === "Quotation" || this.$route.name === "PrivacyPolicy" || this.$route.name === "approveStatus" || this.$route.name === 'ApprovalRequest' || this.$route.name === 'RejectRequest' || this.$route.name === 'returnProcess')) {
        // this.$router.replace("/signin");
      }
    }
    this.currentComponent = this.$route;
    this.$store.commit('setSidebarExpanded', true);
  },
  computed: {
    isSidebarExpanded() {
      return !this.$store.state.isSidebarExpanded;
    },
    checkactiveButton() {
      return this.activeNavButon
    },
    ...mapState({
      currentUser: state => state.currentUser,
      signedIn: state => state.signedIn
    })
  },
  methods: {
    checkDisability(item){
      return (!this.$store.state.app_modules?.includes(item.text) && (this.$store.state.organization_name !== 'Reliance' && this.$store.state.organization_name !== 'Blubirch')) || ((this.$store.state.currentUser.roles.includes('area_service_manager') &&( item.text == 'RIMS' || item.text == 'Reverse Logistics' || item.text == 'Private Marketplace' || item.text == 'Claim Tracking')) || 
              moduleAccessFunc(this.role,item.text) ||  (this.role ==  'logistics_partner' && item.text == 'Reverse Logistics') || (item.text == 'Change Disposition' && this.role !==  'central_admin' && this.role !==  'admin' && this.role != 'warehouse_manager' && this.role != 'site_admin'))
    },
    updateFirstTimeActive(index){
      this.activeIndex = index;
      const parentItem = this.itemsDrawer.find((item) => item.index === index);
      if (parentItem && parentItem.children) {
        this.activeParentIndex = index;
      }else if (parentItem && !parentItem.children) {
        this.activeParentIndex = index;
        this.activeChildIndex = null;
      }else{
        this.itemsDrawer.forEach((item) => {
          if (item.children && item.children.some((child) => child.index === index)) {
            this.activeParentIndex = item.index;
            this.activeChildIndex = index;
          }
        });
      }
    },
    isChildDisabled(item) {
      if(item === 'Manage Buyer' && this.$store.state.data.private_marketplace === false) return true;
      return !this.$store.state.app_modules?.includes(item) && (this.$store.state.organization_name !== 'Reliance' && this.$store.state.organization_name !== 'Blubirch');
    },

    toggleNavbar() {
      this.rail = !this.rail;
      this.$store.commit('setSidebarExpanded', !this.rail);
    },
    handleActivatorClick(index) {
      this.itemsDrawer.forEach((item) => {
        if (item.index !== index && item.children && item.children.length && !item.model) {
          const button = document.getElementById(`button_${item.index}`);
          if (button && !(event && event._programmatic)) {
            const programmaticEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            programmaticEvent._programmatic = true;
            programmaticEvent._index = item.index;
            button.dispatchEvent(programmaticEvent);
          }
        } else
        item.model = item.index !== index ? true : !item.model;
      });
    },
    setActive(index, owner) {
      this.$store.commit('unsetActiveTab');
      this.$store.commit("setpendingApproval", { pending_approval_item: '' });
      this.search = '';
      this.role = this.$store.state.currentUser.roles[0];
      if (index === 107) {
        this.$router.push({ name: 'reverseDisposition' });
      }else if (index === 8) {
        window.open(private_market_place);
      }else if (index === 140) {
        this.$store.commit("setLotIds", {
          lotIds: "AI Pricing File Upload",
          inventoryId: "AI Pricing File Upload",
          action:'first_tab'
        });     
        this.$router.push({ name: "LotFileuploadComm" });
      }else if(index === 106){
        this.$store.commit("resetTourVisits");
      }else if(index === 1107){
        this.$store.commit("updateTitle", {
            title: "Request & Tickets"
          })
      }else if(index === 101){
        this.$store.commit("updateTitle", {
            title: "Return Creation"
          })
      }

      this.activeIndex = index;
      this.$store.commit('setLeftNavbarActive', { active_index: index });
      if (owner === 'child' || owner === 'without_child') {
        this.activeParentIndex = null;
        this.activeChildIndex = null;
      }
        const parentItem = this.itemsDrawer.find((item) => item.index === index);
      if (parentItem && parentItem.children) {
          this.activeParentIndex = index;
        }else{
          this.itemsDrawer.forEach((item) => {
            if (item.children && item.children.some((child) => child.index === index)) {
            this.activeParentIndex = item.index;
            this.activeChildIndex = index;
          }
        });
      }
      this.$store.commit('setActiveIndices', {
        activeParentIndex: this.activeParentIndex,
        activeChildIndex: this.activeChildIndex,
        activeIndex: this.activeIndex
      });
        if(index == 105){
          this.$store.commit("setHeaderTextName",{
            headerTextName : 'Reverse Logistics'
          })
        };
        if(owner == 'parent' || owner == 'without_child'){
          this.handleActivatorClick(index);
      }
    },
    openSearchMenu() {
      this.closeAllMenus(); 
      this.search_popup = true;
    },
    openCollapsedMenu(item) {
      this.closeAllMenus(); 
      this.setActive(item.index)
      this.itemsDrawer.forEach(element => {
        if (element != item) element.v_menu_popup = false
      });
      item.v_menu_popup = !item.v_menu_popup;
    },
    
    closeMenu() {
      this.closeAllMenus();
      // Close the currently open menu and reset openMenuIndex
      if (this.openMenuIndex !== null) {
        this.itemsDrawer[this.openMenuIndex].model = false;
        this.openMenuIndex = null;
      }
    },
    closeAllMenus() {
      this.search_popup = false;
      this.itemsDrawer.forEach(item => {
        item.v_menu_popup = false;
      });
    },
    shouldShowChild(item, child) {
      const hiddenChildIndicesByOrg = {
        Reliance: {
          // 2: [108],
          7: [117, 120],
        },
      }
      if (this.$isRelianceClient() && item.text === 'RIA') {
        return false;
      }
      if(this.organization_name === 'Voltas' && (item.text === 'Generate & Track IDs' || item.text === "Generate Box ID's")){
        return false;
      }
      if (this.organization_name in hiddenChildIndicesByOrg) {
        const hiddenIndicesForItem = hiddenChildIndicesByOrg[this.organization_name][item.index];
        // if (hiddenIndicesForItem && hiddenIndicesForItem.includes(child)) {
        //   return false;
        // }
      }
      if (item.text == 'Settings') {
        if((this.currentUser.roles.includes('admin') && this.$isRelianceClient()) || (this.currentUser.roles.includes('admin') && this.$isWhirlpoolClient())){
          return true;
        }else if((this.currentUser.roles.includes('central_admin') && this.organization_name === 'Voltas')){
          return true;
        }else{
          return false;
        }
        
      }
      
      return true;
    },
    searchItem() {
      this.$store.commit('setSearchedItemId', {
        'searched_tagid': this.search,
        'searched_ird': this.toggle_button
      })
      if (this.search) {
        this.$router.push({
          name: 'ItemInfo',
          query: { search: this.search, key: Date.now() }
        });
      }
    },
    toggleButtonValue() {
      this.search = '';
      this.$store.commit('setSearchedItemId', {
        'searched_tagid': this.search,
        'searched_ird': this.toggle_button
      })
    }
  }
};
</script>
<style scoped>
/* .v-navigation-drawer {
  min-width: 80px !important;
} */

.v-navigation-drawer__content {
  background-color: #1A1B35 !important;
}

.v-menu__content {
  top: 88px !important;
  left: 85px !important;
  min-width: 170px !important;
  border-radius: 9px;
}

:deep(.v-menu .v-overlay__content){
  top: 88px !important;
  left: 70px !important;
  min-width: 170px !important;
  border-radius: 9px;
}

/* :deep(#deployed .v-list-item__content) {
    padding-left: 40px;
  } */

.combined-icon img {
  min-width: 1.5rem;
  opacity: 0.7;
}

:deep(.v-menu__content .v-list-item--active),
:deep(.v-menu__content .v-list-item--active:before) {
  background-color: white;
  border-radius: 9px;
  /* margin: 10px; */
}

.nav-arrow {
  position: absolute;
  top: 18px;
  right: -10px;
  background-color: #E0E1EB;
  color: #1A1B35;
  font-size: 10px;
  height: 20px !important;
  width: 20px !important;
  z-index: 1004;
  cursor: pointer;
}

.compress-icon {
  width: 34px;
  height: 40px;
  position: relative;
  left: -8px;
  right: 0px;
}

:deep(.v-list-item--nav .v-list-item-title) {
  font-size: 14px !important;
  line-height: 19.6px !important;
  font-weight: 600;
}

.font_size {
  font-size: 20px;
}

.active-list-item1 {
  background: linear-gradient(to right, #000d43, #0047ff);
  position: absolute;
  /* right: 2px;
  top: 3px; */
  width: 100%;
  height: 40px;
  opacity: 0.3;
  display: inline;
}
.active-list-item1a{
  background: linear-gradient(to right, #000d43, #0047ff);
  position: absolute;
  width: 100%;
  height: 40px;
  top:0px;
  left: 0px;
  opacity: 0.3;
  display: inline;
}
.active-list-item2 {
  background: #0047ff;
  height: 38px;
  right: 3px;
  /* top: 4px; */
  width: 5px;
  position: absolute;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.active-list-item2a {
  background: #0047ff;
  height: 38px;
  right: 1px;
  top: 1px;
  width: 5px;
  position: absolute;
  /* border-top-left-radius: 6px;
  border-bottom-left-radius: 6px; */
}

.active-list-item3 {
  background: linear-gradient(to right, #ffffff, #2D76FF);
  position: absolute;
  right: -8px;
  width: 30px;
  height: 35px;
  opacity: 50%;
  margin: 20px;
}

.active-list-item4 {
  background: #2D76FF;
  height: 35px;
  right: 7px;
  top: 4px;
  width: 9px;
  position: absolute;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}

.active-list-item5 {
  background: #F6F6F6;
  position: absolute;
  right: 40px;
  width: 110px;
  height: 35px;
  opacity: 30%;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}


.only_icon .v-list-item--active {
  color: #2D76FF !important;
}

.active img,
.btn:hover {
  background-color: #2D76FF;
  border-radius: 4px;
}



button:focus {
  outline: none !important;
}

.sidebar-collapsed {
  width: 58px;
}
.sidebar-expanded{
  width: 256px;
}

:deep(.v-navigation-drawer .mdi-chevron-down) {
  color: white !important;
}
.expand-icon {
  margin-left: auto;
  font-size: 20px;
  color: #ffffff;
  float: right;
}

:deep(.v-list-group .v-list-group__items) {
  margin: 8px 18px 0px 18px;
}

:deep(.v-list-group .v-list-group__items) {
  border-left-style: solid;
  border-left-color: #fff;
  border-left-width: 1px;
}

:deep(.v-input .v-input__slot) {

  border-radius: 8px;
  /* min-height: 40px; */
  background: white !important;
}

:deep(.search-expanded .v-input__prepend-inner) {
  margin-top: 0px !important;
}
:deep(.search-expanded .v-field--variant-outlined){
  background: white !important;
  color: black;
  caret-color: black !important;
}

/*
:deep(.v-input .v-label) {
  top: 10px;
} */

:deep(.customParentSlider.hover, .v-navigation-drawer  .mdi-chevron-down:hover)  {
  color: #5A98E1 !important;
  /* margin-bottom: 8px; */
}

.childHoverSlider.hover {
  background-color: rgba(45, 118, 255, 0.2);
  border-radius: 9px;
  margin-top: 0px;
  height: 40px;
}

.childHover.hover {
  background-color: rgba(224, 225, 235, 1);
  width: 100%;
  display: flex;
  border-radius: 9px;
  padding: 7px;
  padding-left: 0px;
  z-index: 100;

}

.childHoverSlider.disabled {
  color: gray;
  cursor: not-allowed;
  opacity: 0.4;
}

/* .childHoverSlider.disabled:hover {
  background-color: #e0e0e0;
} */

.customParent.hover {
  background-color: rgba(45, 118, 255, 1);
  border-radius: 4px;
}
.parent-item{
  min-height: 40px !important;
  padding: 6px 12px !important;
}
.navbarExpanded{
  width: 236px !important;
}
.menupopup{
  display: relative;
  left: 18px;
  top: 0px;
  overflow: hidden !important;
}
.disabled-span {
  pointer-events: none; 
  opacity: 0.5;
  color: gray;
}
.v-list-item--density-default.v-list-item--one-line{
  min-height: 40px !important;
}
.rounded-search ::v-deep(.v-field) {
  border-radius: 10px !important;
  overflow: hidden;
}
</style>